import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// Import dashboard components from the correct paths
import DashboardHeader from "./components/Header/Header";
import DashboardFooter from "./components/Footer/Footer";
import DashboardPage from "./pages/DashboardPage/DashboardPage";

// Import dashboard styles (create this file with external index.css content)
import "./Dashboard.module.css";

function Dashboard() {
  return (
    <div className="dashboard-app-container">
      <DashboardHeader />
      <main className="dashboard-main-content">
        <Routes>
          {/* Default dashboard route */}
          <Route index element={<DashboardPage />} />
          {/* Add other dashboard routes if needed */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </main>
      <DashboardFooter />
    </div>
  );
}

export default Dashboard;
